export default {
  SET_INTERNAL: 'SET_INTERNAL',
};
